import { ClassData } from '@models/class-data';
import { EventTemplateFont } from '@models/design-templates/event-template-font.model';

export class Brand {
  id: number;

  ownerUserId?: number;
  ownerTeamId?: number;

  name: string;
  description: string;

  fontId: number;
  font: EventTemplateFont;

  primaryColor: string;
  secondaryColor: string;

  logoURL: string;
  imageURL: string;

  isReusable: boolean;

  constructor(json: ClassData<Brand>) {
    this.id = +json.id;

    if (json.ownerUserId !== undefined) {
      this.ownerUserId = +json.ownerUserId;
    }
    if (json.ownerTeamId !== undefined) {
      this.ownerTeamId = +json.ownerTeamId;
    }

    this.name = json.name;
    this.description = json.description;

    this.fontId = +json.fontId;
    this.font = new EventTemplateFont(json.font);

    this.primaryColor = json.primaryColor;
    this.secondaryColor = json.secondaryColor;

    this.logoURL = json.logoURL;
    this.imageURL = json.imageURL;

    this.isReusable = json.isReusable;
  }
}
